module.exports = __webpack_public_path__ + "static/img/lifestyle_34.ebc6f261.png";